import { Typography } from '@mui/material';
import { useDashboardRequest } from './useDashboardRequest';
import { WD } from './warningTheme';

// "Who can set this: Finance, ANU TECH, Project-Foundation department, Client Relations Associate role" - under the title of every threshold screen, so
// anyone who can open the screen sees who else can change it (the people, departments and roles Finance gave this threshold to). For a setup shared by several metrics it also says so ("set together for TAR, ARPU, ...").
// Only a courtesy line: nothing is drawn while it loads or if it cannot be read. GET warning-dashboard/config-access/who/:key has the same
// access as the screen itself.
const WhoCanSet = ({ config }) => {
  const { data } = useDashboardRequest(`warning-dashboard/config-access/who/${config}`);
  if (!data || !Array.isArray(data.people)) return null;
  const metrics = Array.isArray(data.metrics) ? data.metrics : [];
  const groups = Array.isArray(data.groups) ? data.groups : [];
  const groupText = (g) => (g.type === 'role' ? `${g.name}${g.department ? ` (${g.department})` : ''} role` : `${g.name} department`);
  return (
    <Typography variant="caption" component="div" sx={{ color: WD.inkMuted, mt: 0.5 }}>
      Who can set this: Finance{data.people.map((p) => `, ${p.name}`).join('')}{groups.map((g) => `, ${groupText(g)}`).join('')}
      {metrics.length > 1 ? ` · set together for ${metrics.join(', ')}` : ''}
    </Typography>
  );
};

export default WhoCanSet;
